import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type ColorMode = 'light' | 'dark';
export type Language = 'es' | 'en';

interface UiSlice {
  colorMode: ColorMode;
  language: Language;
  /** True once the user picks a language explicitly (toggle). Until then the
   *  unauthenticated funnel may seed the language from the browser. */
  languageExplicit: boolean;
  toggleColorMode: () => void;
  /** Explicit user choice — wins over browser detection and persists. */
  setLanguage: (lang: Language) => void;
  /** Soft, browser-detected default — does NOT mark the choice as explicit. */
  setDetectedLanguage: (lang: Language) => void;
}

export const useUiStore = create<UiSlice>()(
  persist(
    (set) => ({
      colorMode: 'dark',
      language: 'es',
      languageExplicit: false,
      toggleColorMode: () => set((s) => ({ colorMode: s.colorMode === 'dark' ? 'light' : 'dark' })),
      setLanguage: (language) => set({ language, languageExplicit: true }),
      setDetectedLanguage: (language) => set({ language }),
    }),
    {
      name: 'dosfilos-ui',
      partialize: (s) => ({
        colorMode: s.colorMode,
        language: s.language,
        languageExplicit: s.languageExplicit,
      }),
    },
  ),
);
